import { cardImageSrc } from "../constants"
import visaCard from '../../../assets/images/visa.png'

export const cardImageSelector = (type) => {
    return cardImageSrc[type] || visaCard
}
